import { cn } from '@/lib/utils';

export interface ProgressStepsProps {
  total: number;
  current: number;
  className?: string;
}

export function ProgressSteps({ total, current, className }: ProgressStepsProps) {
  return (
    <div className={cn('flex items-center justify-center gap-2', className)}>
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          className={cn(
            'w-2 h-2 rounded-full transition-all duration-300',
            i < current
              ? 'bg-orange-500'
              : i === current
                ? 'bg-orange-500 scale-125'
                : 'bg-slate-600'
          )}
        />
      ))}
    </div>
  );
}
